import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const partsReplacementReportTodo = createAsyncThunk('partsReplacementReport', async ({ params, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `reports/parts-replacement`,
            params: {
                from_date: params?.from_date || undefined,
                to_date: params?.to_date || undefined,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const partsReplacementReportSlice = createSlice({
    name: 'partsReplacementReport',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(partsReplacementReportTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = null
            }
        });
        builder.addCase(partsReplacementReportTodo.rejected, () => { })
    }
})

export default partsReplacementReportSlice.reducer;
